/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useEffect, useState } from 'react';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import FullPageLoader from './FullPageLoader';
import GeneralNavbar from './GeneralNavbar';
import Footer from './Footer';
import './generalPages.css'
import { Button } from 'reactstrap';

const RSSFeed = props => {

    // contexts
    const { theme, fontWeight } = useContext(ThemeContext);

    // states
    const [rSSFeeds, setRSSFeeds] = useState({ title: '', items: [], description: '', lastBuildDate: '' });
    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [showMore, setShowMore] = useState(1);
    const [showAll, setShowAll] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [isLoading, setIsLoading] = useState(false);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setIsLoading(false);
        window.addEventListener('resize', handleWindowSizeChange);
        GeneralService.getRSSFeeds().then(data => {
            try {
                setRSSFeeds(data.rssFeeds);
                setAllCategories(data.allCategories);
                if (data.allCategories.length <= (isMobile ? 4 * showMore : 9 * showMore)) {
                    setShowAll(true);
                } else {
                    setShowAll(false);
                }
                setIsLoading(true);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at General RSSFeed useEffect', 'Error in try catch block', err.stack);
            }
        })
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isMobile = (width <= 768);

    // utility functions
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    // handle functions
    const addCategory = (index) => {
        try {
            let tempArray = [...allCategories];
            const item = tempArray.splice(index, 1);
            setAllCategories(tempArray);
            setSelectedCategories([...selectedCategories, item[0]]);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General RSSFeed addCategory', 'Error in try catch block', err.stack);
        }
    }

    const removeCategory = (index) => {
        try {
            let tempArray = [...selectedCategories];
            const item = tempArray.splice(index, 1);
            setSelectedCategories(tempArray);
            setAllCategories([...allCategories, item[0]]);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General RSSFeed removeCategory', 'Error in try catch block', err.stack);
        }
    }

    const showItem = (item) => {
        try {
            let returnValue = false
            for (let i = 0; i < selectedCategories.length; i++) {
                if (item.category.includes(selectedCategories[i])) {
                    returnValue = true;
                    break;
                }
            }
            return returnValue;
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General RSSFeed showItem', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        !isLoading ?
            <FullPageLoader /> :
            <div className="RSSFeedsMainDiv">
                <ErrorBoundary errorAt="At General RSSFeed GeneralNavbar">
                    <GeneralNavbar history={props.history} />
                </ErrorBoundary>
                <div className="custom-header mb-2">
                    <h3 id="daily-feed-heading">Daily feed</h3>
                </div>
                <ErrorBoundary errorAt="At General RSSFeed Filters">
                    <div className="row m-0">
                        {
                            selectedCategories.map((item, index) => (
                                <Button key={item} className="m-1 activeTag" value={item} onClick={() => removeCategory(index)}>{item}</Button>
                            ))
                        }
                        {
                            allCategories.slice(0,
                                showAll
                                    ?
                                    allCategories.length - selectedCategories.length
                                    :
                                    allCategories.length > (isMobile ? 4 * showMore : 9 * showMore)
                                        ?
                                        ((isMobile ? 4 * showMore : 9 * showMore) - selectedCategories.length)
                                        :
                                        (isMobile ? 4 * showMore : 9 * showMore)
                            ).map((item, index) => (
                                <Button key={item} className="m-1 inactiveTag" value={item} onClick={() => addCategory(index)}>{item}</Button>
                            ))
                        }
                        {
                            showMore > 1 ? <Button className="m-1" onClick={() => { setShowMore(showMore - 1); setShowAll(false); }}>Show Less</Button> : null
                        }
                        {
                            allCategories.length > (isMobile ? 4 * showMore : 9 * showMore) ?
                                <Button className="m-1" onClick={() => { setShowMore(showMore + 1); setShowAll(allCategories.length <= ((isMobile ? 4 * (showMore + 1) : 9 * (showMore + 1)) * ((showMore + 1)))); }}>Show More</Button> : null
                        }
                        {
                            showAll ? null :
                                <Button className="m-1" onClick={() => { setShowAll(true); setShowMore(Math.ceil(allCategories.length / (isMobile ? 4 * showMore : 9 * showMore))) }}>Show All</Button>
                        }
                    </div>
                </ErrorBoundary>
                <ErrorBoundary errorAt="At General RSSFeed Feed">
                    {
                        rSSFeeds.items.map((item, index) => (
                            selectedCategories.length === 0 ?
                                <div key={item.title} className="p-3 m-3" style={theme.card}>
                                    <div style={{ fontSize: '1.4rem', fontWeight: '600' }}>{item.title}</div>
                                    <div style={{ color: 'rgba(0,0,0,0.7)', fontSize: '0.9rem' }}>{rSSFeeds.title} By {item.author} - {item.timeAgo}</div>
                                    <div style={{ fontSize: '1.1rem' }}>{item.description}...<a style={{ textDecoration: 'none', color: '#007bff' }} href={item.link} target="_blank">read more</a></div>
                                </div>
                                :
                                showItem(item) ?
                                    <div key={item.title} className="p-3 m-3" style={theme.card}>
                                        <div style={{ fontSize: '1.4rem', fontWeight: '600' }}>{item.title}</div>
                                        <div style={{ color: 'rgba(0,0,0,0.7)', fontSize: '0.9rem' }}>{rSSFeeds.title} By {item.author} - {item.timeAgo}</div>
                                        <div style={{ fontSize: '1.1rem' }}>{item.description}...<a style={{ textDecoration: 'none', color: '#007bff' }} href={item.link} target="_blank">read more</a></div>
                                    </div>
                                    : null
                        ))
                    }
                </ErrorBoundary>
                <Footer />
            </div>
    )
}

export default RSSFeed;